import { StyledBg, StyledContainer } from './VerticalFormat.styled';

const VerticalFormat: React.FC = () => {
	return (
		<StyledContainer>
			<StyledBg />
			<StyledBg />
		</StyledContainer>
	);
};

export { VerticalFormat };
